module.exports = __webpack_public_path__ + "static/media/rinnegan.e95ab454.png";